import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-nome-equipamento',
  templateUrl: './text-nome-equipamento.component.html',
  styleUrls: ['./text-nome-equipamento.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextNomeEquipamentoComponent implements OnInit {

  get setValue(): string {
    return this.formGroup.get("equipamento").get("nmEquipamento").value
  }

  formGroup: FormGroup;

  constructor(
    private _controlContainer: ControlContainer
  ) {}

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
  }

}
